import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
/* Number from an API value, or null when there is no valid value (null, "", "NaN", arrays, ...) */
export function toFiniteNumber(value) {
  if (value === null || value === undefined || value === "" || typeof value === "object") return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}
